import React, { Component } from 'react';
import ItemsEdit from '../Shared/Items/ItemsNonBooleanDefault';

import {
    stepExcessesSchema,
} from '@swa_llow/pricing_engine';

class ExcessesEdit extends Component {
    render() {
        const { 
            step,
            inputs,
            is_approved,
        } = this.props;

        return <ItemsEdit
            schema={stepExcessesSchema}
            set_error={this.props.set_error}
            updateStep={this.props.updateStep}
            step={step}
            inputs={inputs}
            header={'Excesses'}
            description={'This section allows you to create quote excesses or deductibles'}
            tag={'Excess'}
            is_approved={is_approved}
        />;
    }
}

export default ExcessesEdit;